const acceptedFileTypes = ['image/png', 'image/jpg', 'image/jpeg'] as const;

type AcceptedFileType = (typeof acceptedFileTypes)[number];

export const acceptedTypesImageExtensions = ['.png', '.jpg', '.jpeg'] as const;

export type AcceptedTypesImageExtension =
  (typeof acceptedTypesImageExtensions)[number];

const isAcceptedFileTypes = (fileType: string): fileType is AcceptedFileType =>
  acceptedFileTypes.includes(fileType as AcceptedFileType);

export const mightExtractImageExtFromValidFileType = (
  fileType: string,
): AcceptedTypesImageExtension | null => {
  if (!isAcceptedFileTypes(fileType)) {
    return null;
  }

  return `.${fileType.replace('image/', '')}` as AcceptedTypesImageExtension;
};

const calculateFileSize = (file: File): number => {
  const kb = 1024;
  // eslint-disable-next-line no-magic-numbers
  const mb = kb ** 2;

  // eslint-disable-next-line no-magic-numbers
  return Math.round((file.size / mb) * 100.0) / 100.0;
};

export const acceptableSizeThreshold = 3;

export const isAcceptableFileSize = (file: File): boolean => {
  const size = calculateFileSize(file);

  return size <= acceptableSizeThreshold;
};
